var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAb1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.537369,
    width: 14.5399,
    height: 14.5399,
    rx: 4.07117,
    fill: "#00E194"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.7301,
    width: 14.5399,
    height: 14.5399,
    rx: 4.07117,
    fill: "#00E194"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.9227,
    width: 14.5399,
    height: 14.5399,
    rx: 4.07117,
    fill: "#00E194"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.537369,
    y: 19.54,
    width: 14.5399,
    height: 14.5399,
    rx: 4.07117,
    fill: "#00E194"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19.73,
    y: 19.54,
    width: 14.5399,
    height: 14.5399,
    rx: 4.07117,
    fill: "#00E194"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 38.9227,
    y: 19.54,
    width: 14.5399,
    height: 14.5399,
    rx: 4.07117,
    fill: "#00E194"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0.537369,
    y: 39.0801,
    width: 14.5399,
    height: 14.5399,
    rx: 4.07117,
    fill: "#00E194"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 19.73,
    y: 39.0801,
    width: 14.5399,
    height: 14.5399,
    rx: 4.07117,
    fill: "#00E194"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 38.9227,
    y: 39.0801,
    width: 14.5399,
    height: 14.5399,
    rx: 4.07117,
    fill: "#00E194"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAb1);
export default __webpack_public_path__ + "static/media/ab1.08c7768149187eb8d5409adeeb975dc5.svg";
export { ForwardRef as ReactComponent };